import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type Alert =
  | {
      message: string;
      color: string;
      isError?: boolean;
    }
  | undefined;

interface SceneState {
  popupType: string;
  suppression: boolean;
  alert?: Alert;
}

const initialState: SceneState = {
  popupType: "",
  suppression: false,
  alert: undefined,
};

const sceneSlice = createSlice({
  name: "Scene",
  initialState,
  reducers: {
    sceneStatesTrigger: (state, action: PayloadAction<SceneState>) => {
      state.popupType = action.payload.popupType;
      state.suppression = action.payload.suppression || false;
    },
    setAlert: (state, action: PayloadAction<Alert>) => {
      state.alert = action.payload;
    },
  },
});

export const { sceneStatesTrigger, setAlert } = sceneSlice.actions;

export default sceneSlice.reducer;
